import { UserProfile } from 'stores/types/Profiles';

export const shouldAskForPetDNADisplayNameUpdate = (
  userProfile: UserProfile | null,
): boolean => userProfile?.PetDNADisplayName === null
  || userProfile?.PetDNADisplayName === undefined;
